import { createAsyncThunk } from '@reduxjs/toolkit';
import { axiosInstanceNewAPI } from '@/services/api/utils/axiosInstance';
import { apiPath } from '@/redux/apiPath';
import { mapModelSchema } from '@/models/mapSchema';
import { MapModel, PageOf } from '@/types/models';
import { validateDataUsingZodSchema } from '@/utils/validateDataUsingZodSchema';
import { pageableSchema } from '@/models/pageableSchema';
import { MAPS_SLICE_NAME } from './maps.constants';
import { UpdateMapPayload } from './maps.types';

export const getProjectMaps = createAsyncThunk(
  `${MAPS_SLICE_NAME}/getProjectMaps`,
  async (projectId: string, { rejectWithValue }) => {
    try {
      const response = await axiosInstanceNewAPI.get<PageOf<MapModel>>(
        apiPath.getProjectMaps(projectId),
      );

      const isDataValid = validateDataUsingZodSchema(response.data, pageableSchema(mapModelSchema));

      return isDataValid
        ? response.data.content
        : rejectWithValue({ message: 'Failed to fetch project maps' });
    } catch (error: unknown) {
      if (error instanceof Error) {
        return rejectWithValue({
          name: error.name,
          message: error.message,
        });
      }
      return rejectWithValue({
        name: 'Unknown Error',
        message: 'Failed to fetch project maps',
      });
    }
  },
);

export const updateMap = createAsyncThunk(
  `${MAPS_SLICE_NAME}/updateMap`,
  async ({ projectId, mapId, mapData }: UpdateMapPayload, { rejectWithValue }) => {
    try {
      const response = await axiosInstanceNewAPI.put<MapModel>(
        apiPath.updateMap(projectId, mapId),
        mapData,
      );

      const isDataValid = validateDataUsingZodSchema(response.data, mapModelSchema);

      return isDataValid ? response.data : rejectWithValue({ message: 'Failed to update map' });
    } catch (error: unknown) {
      if (error instanceof Error) {
        return rejectWithValue({
          name: error.name,
          message: error.message,
        });
      }
      return rejectWithValue({
        name: 'Unknown Error',
        message: 'Failed to update map',
      });
    }
  },
);
